import React , {useState,useEffect} from "react";
import { projectsData, projectsNav } from "./data";
import WorksItems from "./worksItems";
const Works = () => {
    const [item, setItem] = useState({name: 'All'});
    const [projects, setProjects ] = useState([]);
    const [active, setActive ] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 6;

    useEffect(()=>{
        if(item.name === "All"){
            // setProjects(projectsData)
            const slicedProjects = projectsData.slice((currentPage - 1) * pageSize, currentPage * pageSize);
            setProjects(slicedProjects);
        }
        else{
            setCurrentPage(1)
            const newProjects = projectsData.filter((project) => {
                return project.category === item.name
            })
            setProjects(newProjects)
        }
    },[item, currentPage])

    const handleClick = (e,index) => {
        e.preventDefault()
        setItem({ name:e.target.textContent });
        setActive(index)
    }
    return (
        <>
            <div className="work__filters">
                {projectsNav.map((item, index) => {
                    return (
                        <button 
                        className={`${active === index ? 'active-work' : '' } work__item` }
                        key={index}
                        onClick={(e) =>{
                            handleClick(e, index);
                        }}
                        >
                        {item.name}
                        </button>
                    )
                })}
            </div>
            <div className="work__container container grid">
                {projects.map((item) => {
                    return(
                        <WorksItems item={item} key={item.id}/>
                    )
                })}
            </div>
            <div className="work__pagination">
            <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
              <span>Page {currentPage}</span>
            <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === projectsData.length / pageSize || currentPage === 3}>Next</button>
            </div>

        </>

    )
}
export default Works;